import { Button, Dropdown, DropdownDivider, TextInput } from "flowbite-react"
import { useMemo, useState } from "react";
import { HiChevronDown } from "react-icons/hi";

interface IRangeDropdownFilterProps {
  label: string;
  onChange?: (value: {from: string, to: string} | string) => void;
}


export const RangeDropdownFilter = (props: IRangeDropdownFilterProps)=>{
    const [fromValue, setFromValue] = useState('');
    const [fromValueLabel, setFromValueLabel] = useState('');
    const [toValue, setToValue] = useState('');
    const [toValueLabel, setToValueLabel] = useState('');

    // TO DO исправить, ref не работает
    const TRIGGER_ID = 'dropdown-trigger-filter-button';   

    const handleApply =() => {
        const triggerButton = document.getElementById(TRIGGER_ID);
        setFromValueLabel(fromValue)
        setToValueLabel(toValue)
        props.onChange && props.onChange({from:fromValue, to: toValue})
        if (triggerButton) {
            triggerButton.click(); 
        }
    };

    const handleReset = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        setFromValue('')   
        setToValueLabel('')   
        setFromValueLabel('')   
        setToValue('') 
        props.onChange && props.onChange('Все')  
    };

    const labelText = useMemo(()=>{
        if(fromValueLabel && toValueLabel) return `${fromValueLabel} - ${toValueLabel}`
        if(fromValueLabel) return `от ${fromValueLabel}`
        if(toValueLabel) return `до ${toValueLabel}`
        return 'Все'
    },[fromValueLabel,toValueLabel])

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        e.stopPropagation();
    };
    return (
        <Dropdown
            className="max-w-fit" 
            color="second" 
            label={props.label}
            dismissOnClick={false}
            renderTrigger={()=>(
                <Button color="second" className='px-3 py-2' id={TRIGGER_ID} >
                    <div className="truncate flex">
                        <div className="text-gray-500 mr-1">{props.label}:</div>
                        <div className="text-gray-900 mr-1">{labelText}</div>
                    </div>
                    {/* Динамическая иконка */}
                        <div className="flex items-center">
                            {fromValueLabel || toValueLabel? (
                            <div onClick={handleReset} >
                                {/* <Icon name="x-outline"
                                    aria-label="Сбросить выбор"
                                    size='10'
                                /> */}
                                ✕
                            </ div>
                            ):(
                            <HiChevronDown
                                className='w-5 h-5 text-gray-900' />
                        )}
                        </div>
                </Button>
            )}
        >
            <div className="p-3 w-64 space-y-3">
            <div className="text-sm font-medium text-gray-900 dark:text-white">
                {props.label}
            </div>
            
            <DropdownDivider />

            <TextInput
                id="from-input"
                type="number"
                placeholder="От:"
                value={fromValue}
                onChange={(e) => setFromValue(e.target.value)}
                onKeyDown={handleKeyDown} 
            />

            <TextInput
                id="to-input"
                type="number"
                placeholder="До:"
                value={toValue}
                onChange={(e) => setToValue(e.target.value)}
                onKeyDown={handleKeyDown} 
            />

            <div className="pt-2">
                <Button
                    onClick={()=>handleApply()}
                    color="primary"
                    className="w-full justify-center"
                    disabled={!fromValue && !toValue}
                    >
                    Применить
                </Button>
            </div>
            </div>
        </Dropdown>
    )
}